import { Injectable } from '@angular/core';
import {GlobalService} from "../../global.config";
import {Observable} from "rxjs";
import {createAuthorizationHeader} from "../../utils/headers";
import {HttpClient} from "@angular/common/http";
import {DriverStationStop} from "../../model/data-managemnt";

@Injectable({
  providedIn: 'root'
})
export class DriverStationStopService {

  constructor(
    private _http: HttpClient,
    private globalService: GlobalService,
  ) { }

  addDriverStationStop(driverStationStop: DriverStationStop): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(this.globalService.dns + "driver-station-stops", driverStationStop, { headers: headers });
  }


  getDriverStationStopByIdDriver(driverId: number): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .get<any>(this.globalService.dns + "driver-station-stops/driver/"+driverId, { headers: headers });
  }


}
